import { useBoolean } from 'usehooks-ts';

import type { Communication } from '@/api/fe-api/entities/communication';

import { CommunicationSidebarListHeader } from './communication-sidebar-list-header';
import { CommunicationSidebarListItem } from './communication-sidebar-list-item';

export type CommunicationSidebarListGroupProps = {
  month: Date;
  communications: Communication[];
};

export function CommunicationSidebarListGroup({
  month,
  communications,
}: CommunicationSidebarListGroupProps) {
  const isCollapsed = useBoolean(true);

  return (
    <div>
      <CommunicationSidebarListHeader
        month={month}
        collapsed={isCollapsed.value}
        onClick={isCollapsed.toggle}
      />
      {isCollapsed.value ? (
        <ul className="divide-y divide-gray-100">
          {communications.map((communication) => (
            <li key={communication.id}>
              <CommunicationSidebarListItem communication={communication} />
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
